const Refresh = () => (
  <svg
    aria-hidden="true"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 8.00005C1.99976 6.68772 2.42039 5.4107 3.1988 4.36057C3.97721 3.31044 5.07141 2.54383 6.31725 2.17576C7.56309 1.80768 8.89338 1.85799 10.1085 2.31914C11.3237 2.78028 12.3582 3.62739 13.0569 4.73338"
      stroke="black"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0772 1V4.73333H9.38477"
      stroke="black"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8C14.0002 9.31233 13.5796 10.5894 12.8012 11.6395C12.0228 12.6896 10.9286 13.4562 9.68272 13.8243C8.43688 14.1924 7.10659 14.1421 5.89143 13.6809C4.67627 13.2198 3.64176 12.3727 2.94312 11.2667"
      stroke="black"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.9231 14.9999V11.2666H6.61548"
      stroke="black"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Refresh
